import { useQuery } from '@tanstack/react-query';
import { useEffect } from 'react';

import { handleQuerySuccess } from '../../../../hooks/useQuriesSuccess';
import { apiRequest } from './../../../../Services/Common/ApiRequest';
import Global from '../../../../Services/Common/Global';
import { mapParamsBySchema } from '../../../../util';
import { NOT_BASIC_01_Schema } from './NOT_BASIC_01_Schema';

/**
 * 공지사항 기본정보(NOT_BASIC_01) 관련 React Query 훅 모음
 * - 기본 조회(useQuery): useSearch1
 *
 * 만약 MUTATION 훅에서 공통 응답 처리 외에 추가 성공 콜백이 필요하면
 * successOptions 파라미터로 onSuccess 콜백 함수를 넘겨줄 수 있다.
 */
export const useSearch1 = (options = {}) => {
  const { onSuccess } = options;
  const params = mapParamsBySchema(NOT_BASIC_01_Schema.mapper.search1);

  const query = useQuery({
    queryKey: ['notice', 'getNotBasicR1', params],
    queryFn: () => apiRequest('post', Global.urls.Notice.getNotBasicR1, params),
    enabled: true, // 자동 실행 여부
  });

  useEffect(() => {
    if (!query.isSuccess) return;

    handleQuerySuccess(query.data, {
      onSuccess: async (rows) => {
        await onSuccess?.(rows);
      },
    });
  }, [query.isSuccess, query.dataUpdatedAt]);

  return query;
};
